/**
 * Component adapted from SEAC Corporate Website
 * https://github.com/oozou/seac-corporate-website/blob/v1.0.3/packages/web/src/help-center/TopBanner.tsx
 */

import React from 'react';
import CircleQuarter from '../ui-kit/icons/CircleQuarter';

export interface ITopBanner {
  title: string;
  description: string;
}

export const TopBanner: React.FC<ITopBanner> = ({ title, description }) => {
  return (
    <div className="flex w-full justify-center bg-brand-secondary">
      <div className="relative flex w-full max-w-screen-lg flex-col  justify-between md:flex-row md:space-x-8 lg:max-h-[410px] lg:px-6">
        <div
          className="flex w-full max-w-[570px] flex-grow flex-col px-6 py-10 text-white md:w-1/2 lg:w-full lg:px-0 lg:py-27"
          style={{ maxWidth: 570 }}
        >
          <p className="mb-6 text-hero-mobile font-bold lg:mb-12 lg:text-hero-desktop ">
            {title}
          </p>
          <p className="text-body font-regular">{description}</p>
        </div>
        <RightGraphicMobile />
        <RightGraphic />
      </div>
    </div>
  );
};

const RightGraphic: React.FC<any> = () => {
  return (
    <div
      className="relative bottom-0 left-0 hidden w-[615px] overflow-x-visible lg:block"
      style={{ width: 615 }}
    >
      <CircleQuarter
        className="absolute left-[205px] top-0 h-[205px] w-[205px] rotate-180 transform text-brand-primary"
        style={{ width: 205, height: 205, top: 0, left: 205 }}
      />
      <CircleQuarter
        className="absolute left-[410px] top-0 h-[205px] w-[205px] rotate-90 transform text-blue-500"
        style={{ width: 205, height: 205, top: 0, left: 410 }}
      />
      <CircleQuarter
        className="absolute left-0 top-[205px] h-[205px] w-[205px] text-blue-500"
        style={{ width: 205, height: 205, top: 205, left: 0 }}
      />
      <div
        className="absolute left-[205px] top-[205px] h-[205px] w-[205px] bg-orange-400"
        style={{ width: 205, height: 205, top: 205, left: 205 }}
      ></div>
      <CircleQuarter
        className="absolute left-[410px] top-[205px] h-[205px] w-[205px] rotate-180 transform text-maroon-500"
        style={{ width: 205, height: 205, top: 205, left: 410 }}
      />
    </div>
  );
};

const RightGraphicMobile: React.FC<any> = () => {
  return (
    <div
      className="relative block h-[250px] w-full md:w-1/2 lg:hidden"
      style={{ height: 250 }}
    >
      <CircleQuarter
        className="absolute bottom-[125px] left-[125px] h-[125px] w-[125px] rotate-180 transform text-brand-primary"
        style={{ width: 125, height: 125, bottom: 125, left: 125 }}
      />
      <CircleQuarter
        className="absolute bottom-[125px] left-[250px] h-[125px] w-[125px] rotate-90 transform text-blue-500"
        style={{ width: 125, height: 125, bottom: 125, left: 250 }}
      />
      <CircleQuarter
        className="absolute bottom-0 left-0 h-[125px] w-[125px] transform text-blue-500"
        style={{ width: 125, height: 125 }}
      />
      <div
        className="absolute bottom-0 left-[125px] h-[125px] w-[125px] bg-orange-400"
        style={{ width: 125, height: 125, left: 125 }}
      ></div>
      <CircleQuarter
        className="absolute bottom-0 left-[250px] h-[125px] w-[125px] rotate-180 transform text-maroon-500"
        style={{ width: 125, height: 125, left: 250 }}
      />
    </div>
  );
};
